import * as React from 'react'

/** The heading of the sheet whose content is being drawn, or `null` outside any sheet. */
export type EntryTitleComponent = React.ForwardRefExoticComponent<
  React.ComponentPropsWithoutRef<'h2'> & {
    asChild?: boolean
  } & React.RefAttributes<HTMLHeadingElement>
>

// Why a context: a page's title (`PageTitle`, so `PageHeader`) is the sheet's title when the page
// is shown in one, and the pages do not know whether they are. The context hands them the heading.
export const EntryTitleContext = React.createContext<EntryTitleComponent | null>(null)
